// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"41ZY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopLevelNav", ()=>TopLevelNav);
parcelHelpers.export(exports, "MaintenanceDropdown", ()=>MaintenanceDropdown);
parcelHelpers.export(exports, "ReportsDropdown", ()=>ReportsDropdown);
parcelHelpers.export(exports, "AppsDropdown", ()=>AppsDropdown);
parcelHelpers.export(exports, "MobileFiltersToggler", ()=>MobileFiltersToggler);
parcelHelpers.export(exports, "MobileFiltersCard", ()=>MobileFiltersCard);
parcelHelpers.export(exports, "MobileToggles", ()=>MobileToggles);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _rbac = require("../../Constants/RBAC");
var _routes = require("../../Constants/Routes");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _toggleSwitch = require("../Map/ToggleSwitch");
var _toggleSwitchDefault = parcelHelpers.interopDefault(_toggleSwitch);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
const { className: navLinkClass, styles: navLinkStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "906949913",
        children: "a.jsx-906949913{color:var(--text-gray);}a.jsx-906949913:hover,.active.jsx-906949913{color:var(--brand-primary) !important;}"
    }),
    className: "jsx-906949913"
};
const { className: dropdownClassName, styles: dropdownStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1185273954",
        children: "li.jsx-1185273954{color:var(--text-gray) !important;}li.jsx-1185273954:hover,.active.jsx-1185273954{color:var(--brand-primary) !important;}"
    }),
    className: "jsx-1185273954"
};
const { className: itemClassName, styles: itemStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1366763783",
        children: "a.jsx-1366763783{color:var(--text-gray) !important;outline:none !important;}a.jsx-1366763783:hover,.active.jsx-1366763783{background:transparent;color:var(--brand-primary) !important;}"
    }),
    className: "jsx-1366763783"
};
const { className: partsMenuClassName, styles: partsMenuStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3125594744",
        children: ".dropdown-menu.jsx-3125594744{z-index:9999;}"
    }),
    className: "jsx-3125594744"
};
function TopLevelNav({ path, isActive, children, ...rest }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.NavItem), {
        className: "d-flex align-items-center mx-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.NavLink), {
                active: isActive,
                className: `${navLinkClass} transition-fade`,
                tag: (0, _reactRouterDom.Link),
                to: path,
                ...rest,
                children: children
            }),
            navLinkStyles
        ]
    });
}
TopLevelNav.propTypes = {
    path: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    isActive: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).node,
    replace: (0, _propTypesDefault.default).bool
};
TopLevelNav.defaultProps = {
    path: ""
};
function MaintenanceDropdown({ partsIsActive, scheduleIsActive, serviceIsActive }) {
    const { features: { parts } = {} } = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
        active: partsIsActive || serviceIsActive || scheduleIsActive,
        className: `${dropdownClassName} d-flex align-items-center mx-2`,
        inNavbar: true,
        nav: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                className: "h-100 d-flex align-items-center transition-fade text-reset text-decoration-none py-0 shadow-none",
                color: "link",
                nav: true,
                children: "Maintenance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                className: `mt-2 shadow ${partsIsActive ? partsMenuClassName : ""}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: serviceIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        disabled: serviceIsActive,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.MAINTENANCE)}?tab=service`,
                        children: "Dashboard"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: scheduleIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        disabled: scheduleIsActive,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.MAINTENANCE)}?tab=schedules`,
                        children: "Schedules"
                    }),
                    parts ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: partsIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        disabled: partsIsActive,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.MAINTENANCE)}?tab=parts`,
                        children: "Parts"
                    }) : null
                ]
            }),
            dropdownStyles,
            itemStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3117138083",
                children: ".dropdown-menu{outline:none;}"
            })
        ]
    });
}
MaintenanceDropdown.propTypes = {
    partsIsActive: (0, _propTypesDefault.default).bool,
    scheduleIsActive: (0, _propTypesDefault.default).bool,
    serviceIsActive: (0, _propTypesDefault.default).bool
};
function ReportsDropdown() {
    const { _id: orgID, features: { csvExport, maintenance_v2: { enabled: maintenanceReportsEnabled } = {} } = {} } = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const csvIsActive = (0, _react.useMemo)(()=>pathname.includes((0, _routes.CSV_REPORTS)), [
        pathname
    ]), fleetIsActive = (0, _react.useMemo)(()=>pathname.includes((0, _routes.FLEET)), [
        pathname
    ]), maintenanceReportsIsActive = (0, _react.useMemo)(()=>pathname.includes((0, _routes.MAINTENANCE_REPORT)), [
        pathname
    ]), utilizationIsActive = (0, _react.useMemo)(()=>pathname.includes((0, _routes.REPORTS)), [
        pathname
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
        active: csvIsActive || fleetIsActive || maintenanceReportsIsActive || utilizationIsActive,
        className: `${dropdownClassName} d-flex align-items-center mx-2`,
        inNavbar: true,
        nav: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                className: "h-100 d-flex align-items-center transition-fade text-reset text-decoration-none py-0 shadow-none",
                color: "link",
                nav: true,
                children: "Reports"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                className: "mt-2 shadow",
                children: [
                    csvExport?.signals > 0 || csvExport?.onDemand ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: csvIsActive,
                        disabled: csvIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.CSV_REPORTS)}?tab=${csvExport.signals > 0 ? "scheduled" : "on-demand"}`,
                        children: "CSV Export"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: fleetIsActive,
                        disabled: fleetIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        tag: (0, _reactRouterDom.Link),
                        to: (0, _routes.FLEET),
                        children: "Fleet"
                    }),
                    maintenanceReportsEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: orgID,
                        perform: (0, _rbac.MAINTENANCE_READ),
                        resource: (0, _rbac.MAINTENANCE),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                active: maintenanceReportsIsActive,
                                disabled: maintenanceReportsIsActive,
                                className: `${itemClassName} nine-tenth-text`,
                                tag: (0, _reactRouterDom.Link),
                                to: (0, _routes.MAINTENANCE_REPORT),
                                children: "Maintenance"
                            })
                    }) : null
                ]
            }),
            dropdownStyles,
            itemStyles,
            partsMenuStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3117138083",
                children: ".dropdown-menu{outline:none;}"
            })
        ]
    });
}
function AppsDropdown({ engineanalysisIsActive, waterpumpIsActive }) {
    const { _id: currentOrgID, features: { apps = [] } = {} } = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    return apps.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
        active: waterpumpIsActive || engineanalysisIsActive,
        className: `${dropdownClassName} d-flex align-items-center mx-2`,
        inNavbar: true,
        nav: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                className: "h-100 d-flex align-items-center transition-fade text-reset text-decoration-none py-0 shadow-none",
                color: "link",
                nav: true,
                children: "Apps"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                className: "mt-2 shadow",
                children: [
                    apps.includes("engineanalysis") ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: engineanalysisIsActive,
                        disabled: engineanalysisIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.ENGINEANALYSIS)}?orgID=${currentOrgID}&viewing=orgsList`,
                        children: "Cummins Diagnostics"
                    }) : null,
                    apps.includes("waterpump") ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        active: waterpumpIsActive,
                        disabled: waterpumpIsActive,
                        className: `${itemClassName} nine-tenth-text`,
                        tag: (0, _reactRouterDom.Link),
                        to: `${(0, _routes.WATERTRANSFER)}?orgID=${currentOrgID}`,
                        children: "Water Transfer"
                    }) : null
                ]
            }),
            dropdownStyles,
            itemStyles
        ]
    }) : null;
}
AppsDropdown.propTypes = {
    engineanalysisIsActive: (0, _propTypesDefault.default).bool,
    waterpumpIsActive: (0, _propTypesDefault.default).bool
};
function MobileFiltersToggler({ buttonStyles, toggleMobileFilters }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
        className: "bg-transparent shadow-none text-decoration-none text-brand-primary position-absolute",
        onClick: toggleMobileFilters,
        color: "link",
        type: "button",
        style: {
            right: "0.5rem",
            ...buttonStyles
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: (0, _freeSolidSvgIcons.faSlidersH),
            size: "lg"
        })
    });
}
MobileFiltersToggler.propTypes = {
    buttonStyles: (0, _propTypesDefault.default).object,
    toggleMobileFilters: (0, _propTypesDefault.default).func
};
MobileFiltersToggler.defaultProps = {
    buttonStyles: {}
};
function MobileFiltersCard({ children, handleSearchTerm, open }) {
    const inputRef = (0, _react.useRef)(null), location = (0, _reactRouterDom.useLocation)(), onMap = location.pathname.includes("map");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
        className: `${open ? "d-flex" : "d-none"} mt-1 mx-4`,
        style: {
            borderRadius: "20px",
            padding: "10px",
            zIndex: "1"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.NavItem), {
                className: "list-unstyled",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        style: {
                            marginLeft: "7px"
                        },
                        className: "jsx-1856195729 font-weight-medium mb-0 text-text-dark",
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1856195729 mb-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.InputGroup), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-1856195729 row w-100 ml-0",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.InputGroupAddon), {
                                            addonType: "prepend",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: inputRef.current && inputRef.current.focus,
                                                className: "jsx-1856195729 bg-transparent p-0 ml-1 btn btn-link text-decoration-none",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: "text-text-light-gray",
                                                    icon: (0, _freeSolidSvgIcons.faSearch)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            onChange: handleSearchTerm,
                                            onKeyDown: (e)=>{
                                                if (e.keyCode !== 13) return;
                                                handleSearchTerm(e);
                                                inputRef.current.blur();
                                            },
                                            ref: inputRef,
                                            placeholder: "Search Inventory",
                                            style: {
                                                outline: "none"
                                            },
                                            className: "jsx-1856195729 asset-search w-75 ml-2 rounded-0 border-top-0 border-left-0 border-right-0 shadow-none"
                                        })
                                    ]
                                })
                            }),
                            onMap ? children : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1856195729",
                children: ".asset-search.jsx-1856195729::-webkit-input-placeholder{color:#d2d2d2;}.asset-search.jsx-1856195729::-moz-placeholder{color:#d2d2d2;}.asset-search.jsx-1856195729:-ms-input-placeholder{color:#d2d2d2;}.asset-search.jsx-1856195729::placeholder{color:#d2d2d2;}"
            })
        ]
    });
}
MobileFiltersCard.propTypes = {
    children: (0, _propTypesDefault.default).node,
    handleSearchTerm: (0, _propTypesDefault.default).func,
    open: (0, _propTypesDefault.default).bool
};
function MobileToggles(props) {
    const { handleAlarmAssetToggle, handleEcosystemAssetToggle, handleGeofenceToggle, handleOfflineAssetToggle, showEcosystem, showGeofences, showOfflineAssets, showOnlyActiveAlarms } = props;
    const { _id: orgID } = (0, _react.useContext)((0, _currentOrgContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "font-weight-light my-2 ml-2",
                children: "Show"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "font-weight-normal text-text-light-gray",
                style: {
                    fontSize: "0.9rem",
                    marginLeft: "3px"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                                checked: showEcosystem,
                                disabled: true,
                                children: "Suborg Assets"
                            }),
                        orgID: orgID,
                        perform: (0, _rbac.CORE_READ),
                        resource: (0, _rbac.CORE),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                                onChange: handleEcosystemAssetToggle,
                                checked: showEcosystem,
                                children: "Suborg Assets"
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                        onChange: handleAlarmAssetToggle,
                        checked: showOnlyActiveAlarms,
                        children: "Active Alarms"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                        onChange: handleOfflineAssetToggle,
                        checked: showOfflineAssets,
                        children: "Offline Assets"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: orgID,
                        perform: (0, _rbac.GEOFENCE_READ),
                        resource: (0, _rbac.GEOFENCE),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSwitchDefault.default), {
                                onChange: handleGeofenceToggle,
                                checked: showGeofences,
                                children: "Geofences"
                            })
                    })
                ]
            })
        ]
    });
}
MobileToggles.propTypes = {
    handleAlarmAssetToggle: (0, _propTypesDefault.default).func,
    handleEcosystemAssetToggle: (0, _propTypesDefault.default).func,
    handleGeofenceToggle: (0, _propTypesDefault.default).func,
    handleOfflineAssetToggle: (0, _propTypesDefault.default).func,
    showEcosystem: (0, _propTypesDefault.default).bool,
    showGeofences: (0, _propTypesDefault.default).bool,
    showOfflineAssets: (0, _propTypesDefault.default).bool,
    showOnlyActiveAlarms: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/RBAC":"ieo1E","../../Constants/Routes":"3Lt5k","../../Context/CurrentOrgContext":"jQXcJ","../Map/ToggleSwitch":"dcF5L","../../RBAC/Can":"l4l8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcF5L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToggleSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
function ToggleSwitch(props) {
    const { checked, children, disabled, geofencesLoading, onChange } = props;
    const restrictedTooltip = (0, _react.useMemo)(()=>disabled && children === "Suborg Assets" ? {
            "data-tip": "This action is restricted based on your access level"
        } : {}, [
        children,
        disabled
    ]);
    const { isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            marginLeft: "-14px"
        },
        ...restrictedTooltip,
        className: (0, _styleDefault.default).dynamic([
            [
                "2271585474",
                [
                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                ]
            ]
        ]) + " " + (restrictedTooltip && restrictedTooltip.className != null && restrictedTooltip.className || "row align-items-center"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                htmlFor: `toggle-switch-input-${children}`,
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2271585474",
                        [
                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                        ]
                    ]
                ]) + " " + "switch position-relative d-inline-block",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        checked: checked,
                        disabled: disabled,
                        id: `toggle-switch-input-${children}`,
                        onChange: onChange,
                        type: "checkbox",
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2271585474",
                                [
                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ])
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2271585474",
                                [
                                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                                ]
                            ]
                        ]) + " " + "slider position-absolute round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2271585474",
                        [
                            isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                        ]
                    ]
                ]) + " " + `mb-0 text-text-light-gray ${geofencesLoading ? "mr-4" : ""}`,
                children: children
            }),
            geofencesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                color: "var(--brand-primary)",
                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                spin: true
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2271585474",
                dynamic: [
                    isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"
                ],
                children: `.switch.__jsx-style-dynamic-selector{width:34px;height:20px;margin-left:6%;margin-right:6%;margin-top:4px;margin-bottom:4px;}.switch.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{opacity:0;width:0;height:0;}.slider.__jsx-style-dynamic-selector{cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:var(--light-gray-3);-webkit-transition:0.4s;-webkit-transition:0.4s;transition:0.4s;}.slider.__jsx-style-dynamic-selector:before{position:absolute;content:'';height:17px;width:17px;left:1px;bottom:1px;background-color:white;-webkit-transition:0.4s;-webkit-transition:0.4s;transition:0.4s;}input.__jsx-style-dynamic-selector:checked+.slider.__jsx-style-dynamic-selector{background-color:var( --${isVersatileUi || isSupraUi ? "brand-primary" : "highlight-blue"} );}input.__jsx-style-dynamic-selector:focus+.slider.__jsx-style-dynamic-selector{box-shadow:0 0 1px #2196f3;}input.__jsx-style-dynamic-selector:checked+.slider.__jsx-style-dynamic-selector:before{-webkit-transform:translateX(15px);-ms-transform:translateX(15px);-webkit-transform:translateX(15px);-ms-transform:translateX(15px);transform:translateX(15px);}.slider.round.__jsx-style-dynamic-selector{border-radius:34px;}.slider.round.__jsx-style-dynamic-selector:before{border-radius:50%;}`
            })
        ]
    });
}
ToggleSwitch.propTypes = {
    checked: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).oneOf([
        "Suborg Assets",
        "Active Alarms",
        "Offline Assets",
        "Geofences"
    ]),
    disabled: (0, _propTypesDefault.default).bool,
    geofencesLoading: (0, _propTypesDefault.default).bool,
    onChange: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-tooltip":"4ejwp","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/BrandingContext":"bKKTd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},[], null, "parcelRequire287b")

//# sourceMappingURL=Header.78f3e34e.js.map
